import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Youtube } from 'lucide-react';
import logo from "../assets/logo.png";

const Footer = () => {
  const playStoreUrl =
    "https://play.google.com/store/apps/details?id=com.retailmitra&hl=en_IN";

  return (
    <footer className="bg-slate-900 text-slate-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand Info */}
          <div>
            <div className="h-16 w-16 rounded-full bg-white flex items-center justify-center overflow-hidden shadow-lg mb-4">
              <img
                src={logo}
                alt="RetailMitra Logo"
                className="h-12 w-12 object-contain"
              />
            </div>

            <p className="text-sm leading-relaxed mb-6">
              #1 billing & inventory app for Kirana stores. Making small businesses
              digital, one shop at a time. Made with ❤️ in India.
            </p>

            <div className="flex gap-4">
              <Facebook size={20} className="hover:text-emerald-400 cursor-pointer" />
              <Twitter size={20} className="hover:text-emerald-400 cursor-pointer" />
              <Instagram size={20} className="hover:text-emerald-400 cursor-pointer" />
              <Youtube size={20} className="hover:text-emerald-400 cursor-pointer" />
            </div>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-white font-bold mb-6">Product</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#features" className="hover:text-white">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-white">How It Works</a></li>
              <li>
                <a
                  href={playStoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  Download App
                </a>
              </li>
              <li><a href="#" className="hover:text-white">Updates</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-bold mb-6">Company</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#" className="hover:text-white">About Us</a></li>
              <li><a href="#" className="hover:text-white">Careers</a></li>
              <li><a href="#" className="hover:text-white">Blog</a></li>
              <li><a href="#" className="hover:text-white">Press</a></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-white font-bold mb-6">Support</h4>
            <ul className="space-y-4 text-sm">
              <li><a href="#" className="hover:text-white">Help Center</a></li>
              <li><a href="#" className="hover:text-white">Contact Us</a></li>
              <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs">
          <p>© 2024 RetailMitra. All rights reserved.</p>

          <div className="flex gap-6">
            {/* Google Play */}
            <a
              href={playStoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:scale-105 transition-transform"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-8"
              />
            </a>

            {/* App Store (future ready) */}
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
              alt="App Store"
              className="h-8 opacity-60"
            />
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
